import { render, staticRenderFns } from "./DocumentacaoProdutos.vue?vue&type=template&id=6ca7a894&scoped=true"
import script from "./DocumentacaoProdutos.vue?vue&type=script&lang=js"
export * from "./DocumentacaoProdutos.vue?vue&type=script&lang=js"
import style0 from "./DocumentacaoProdutos.vue?vue&type=style&index=0&id=6ca7a894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca7a894",
  null
  
)

export default component.exports